import PartiesDataUpdate from "./partiesDataUpdate";
import diagramsInit from "./diagramsInit";
import { diagramsConfigInit } from "../models/diagramsConfig";
import partiesV2 from "../models/partiesV2";

const DataFiltering = (movingAverageRange, filter, data, type) => {
    diagramsInit(partiesV2, type)
    diagramsConfigInit(partiesV2, type);
    data.forEach((poll) => {
        if (filter.value !== 0) {
            if (filter.label === poll.company.name) {
                partiesV2.forEach((party, index) => {
                    if (type === "evaluation" && index<partiesV2.length-3) {
                        PartiesDataUpdate(movingAverageRange, poll, index, party.data.evaluation, type, party);
                    }
                    else if (type === "intention") {
                        PartiesDataUpdate(movingAverageRange, poll, index, party.data.intention, type, party);
                    }
                    
                })
            }
        }
        else {
            partiesV2.forEach((party, index) => {
                if (type === "evaluation" && index<partiesV2.length-3) {
                    PartiesDataUpdate(movingAverageRange, poll, index, party.data.evaluation, type, party);
                }
                else if (type === "intention") {
                    PartiesDataUpdate(movingAverageRange, poll, index, party.data.intention, type, party);
                }
            })
        }
    });
}
export default DataFiltering;